import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import jsCookie from 'js-cookie';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faTimes } from '@fortawesome/free-solid-svg-icons';

import FixedSideButton from '@atoms/FixedSideButton';
import { useScreenSmDown } from '@hooks/useResponsive';

const FixedInformationButton = ({ children, cookieName, labelText = 'Information' }) => {
    const isScreenSmDown = useScreenSmDown();

    // -----------------------------
    // State
    // -----------------------------

    const [showPopout, setShowPopout] = useState(jsCookie.get(cookieName) !== '1');

    // -----------------------------
    // Effects
    // -----------------------------

    useEffect(() => {
        jsCookie.set(cookieName, 1);
    }, [cookieName]);

    // -----------------------------
    // Render
    // -----------------------------

    return (
        <div>
            <FixedSideButton
                bottom="6rem"
                bottomMobile="1rem"
                labelText={labelText}
                highlight={showPopout}
                icon={<FontAwesomeIcon icon={faInfoCircle} color="white" />}
                onClick={() => {
                    setShowPopout(!showPopout);
                }}
            />

            {showPopout && (
                <div style={styles.popoutContainerOuter(isScreenSmDown)}>
                    <div style={styles.popoutContainerInner(isScreenSmDown)}>
                        <div className="d-flex justify-content-end">
                            <a
                                href="#"
                                style={styles.icon}
                                onClick={e => {
                                    e.preventDefault();
                                    setShowPopout(false);
                                }}
                            >
                                <FontAwesomeIcon icon={faTimes} />
                            </a>
                        </div>

                        <div>{children}</div>
                    </div>
                </div>
            )}
        </div>
    );
};

const styles = {
    popoutContainerOuter: isScreenSmDown => ({
        background: '#a7a1ab',
        padding: '10px',
        position: 'fixed',
        right: '2.5rem',
        zIndex: '99999',
        bottom: isScreenSmDown ? '2.5rem' : '6rem',
        left: isScreenSmDown ? '2.5rem' : 'auto',
        top: isScreenSmDown ? '2.5rem' : 'auto',
        width: isScreenSmDown ? 'auto' : '390px',
    }),
    popoutContainerInner: isScreenSmDown => ({
        background: '#fff',
        overflow: 'scroll',
        padding: '12px 20px',
        position: isScreenSmDown ? 'absolute' : 'static',
        top: isScreenSmDown ? '12px' : 'auto',
        right: isScreenSmDown ? '12px' : 'auto',
        bottom: isScreenSmDown ? '12px' : 'auto',
        left: isScreenSmDown ? '12px' : 'auto',
    }),
    link: {
        cursor: 'pointer',
        textDecoration: 'underline',
    },
    divider: {
        borderTop: '1px solid #000',
    },
};

FixedInformationButton.propTypes = {
    children: PropTypes.node.isRequired,
    cookieName: PropTypes.string.isRequired,
    labelText: PropTypes.string,
};

export default FixedInformationButton;
